export default __webpack_public_path__ + "fonts/arrow-right-white.svg";